const ONES = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine',
  'Ten', 'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
const TENS = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

function threeDigitsToWords(n: number): string {
  let str = '';
  if (n >= 100) {
    str += ONES[Math.floor(n / 100)] + ' Hundred ';
    n %= 100;
  }
  if (n >= 20) {
    str += TENS[Math.floor(n / 10)] + ' ';
    n %= 10;
  }
  if (n > 0) {
    str += ONES[n] + ' ';
  }
  return str.trim();
}

// Indian numbering system: Crore, Lakh, Thousand, Hundred
function indianNumberToWords(num: number): string {
  if (num === 0) return 'Zero';
  let str = '';
  const crore = Math.floor(num / 10000000); num %= 10000000;
  const lakh = Math.floor(num / 100000); num %= 100000;
  const thousand = Math.floor(num / 1000); num %= 1000;
  const hundred = num;

  if (crore) str += threeDigitsToWords(crore) + ' Crore ';
  if (lakh) str += threeDigitsToWords(lakh) + ' Lakh ';
  if (thousand) str += threeDigitsToWords(thousand) + ' Thousand ';
  if (hundred) str += threeDigitsToWords(hundred) + ' ';

  return str.trim();
}

// International numbering system: Billion, Million, Thousand, Hundred
function internationalNumberToWords(num: number): string {
  if (num === 0) return 'Zero';
  let str = '';
  const billion = Math.floor(num / 1000000000); num %= 1000000000;
  const million = Math.floor(num / 1000000); num %= 1000000;
  const thousand = Math.floor(num / 1000); num %= 1000;
  const hundred = num;

  if (billion) str += threeDigitsToWords(billion) + ' Billion ';
  if (million) str += threeDigitsToWords(million) + ' Million ';
  if (thousand) str += threeDigitsToWords(thousand) + ' Thousand ';
  if (hundred) str += threeDigitsToWords(hundred) + ' ';

  return str.trim();
}

const INDIAN_SYSTEM_CURRENCIES = ['INR', 'NPR', 'PKR', 'BDT', 'LKR'];

const CURRENCY_NAMES: Record<string, { main: string; sub: string }> = {
  INR: { main: 'Rupees', sub: 'Paise' },
  USD: { main: 'Dollars', sub: 'Cents' },
  GBP: { main: 'Pounds', sub: 'Pence' },
  EUR: { main: 'Euros', sub: 'Cents' },
  AED: { main: 'Dirhams', sub: 'Fils' },
  SAR: { main: 'Riyals', sub: 'Halalas' },
  QAR: { main: 'Riyals', sub: 'Dirhams' },
  KWD: { main: 'Dinars', sub: 'Fils' },
  OMR: { main: 'Rials', sub: 'Baisa' },
  BHD: { main: 'Dinars', sub: 'Fils' },
  PKR: { main: 'Rupees', sub: 'Paisa' },
  BDT: { main: 'Taka', sub: 'Paisa' },
  NPR: { main: 'Rupees', sub: 'Paisa' },
  LKR: { main: 'Rupees', sub: 'Cents' },
  AUD: { main: 'Dollars', sub: 'Cents' },
  CAD: { main: 'Dollars', sub: 'Cents' },
  SGD: { main: 'Dollars', sub: 'Cents' },
  MYR: { main: 'Ringgit', sub: 'Sen' },
};

export function amountToWords(amount: number, currencyCode: string = 'INR'): string {
  const code = (currencyCode || 'INR').toUpperCase();
  const names = CURRENCY_NAMES[code] || { main: code, sub: 'Cents' };
  const useIndianSystem = INDIAN_SYSTEM_CURRENCIES.includes(code);
  const toWords = useIndianSystem ? indianNumberToWords : internationalNumberToWords;

  const whole = Math.floor(amount);
  const fraction = Math.round((amount - whole) * 100);

  let result = toWords(whole) + ' ' + names.main;
  if (fraction > 0) {
    result += ' and ' + toWords(fraction) + ' ' + names.sub;
  }
  result += ' Only';

  return result;
}